export const FETCH_MOST_ACCESSED_ACCOUNTS_SUCCESS = "FETCH_MOST_ACCESSED_ACCOUNTS_SUCCESS";
